<template>
  <div id="main_view">
    <a-spin :spinning="totalSpinning" size="large">
      <a-spin :spinning="spinning" size="large">
        <div>
          <nav-top/>
        </div>
        <div class="boxDivs">
          <div class="serveDiv" v-if="isShow">
            <div class="serveDivContent" onclick= "window.open('https://www.yuque.com/books/share/f559ab5a-04ec-431c-8b92-01752aab907f?# 《《分类分级干预与预防》流程》')">
              <img src="@/assets/zhinan.png" alt="">
            </div>
          </div>
          <div class="contents">
            <div class="content-box">
              <router-view/>
            </div>
          </div>
        </div>
      </a-spin>
    </a-spin>
    <div v-if="spinning && dataManagementShwoProgress" class="exportProgress">
      <a-progress :percent="parseFloat(fixedFun((exportProgress + exportProgressOther) / 2))" />
      <p style="padding-top: 50px;">正在批量导出报告，可能会花上一段时间，请耐心等待不要关闭此页面</p>
    </div>
    <div v-if="totalSpinning" class="spin_btn">
      <a-progress :percent="parseFloat(importPro)" />
      <p style="padding-top: 50px;">正在批量导入学生，可能会花上一段时间，请耐心等待不要关闭此页面</p>
      <a-button @click="clearHandle" class="clear_btn">取消导入</a-button>
    </div>
    <div class="ke_fu" v-if="userInfo && userInfo.type === 2">
      <img src="@/assets/kefu.png" alt="" @click="showDrawer">
      <a-drawer
        placement="right"
        :closable="false"
        :visible="visible"
        :after-visible-change="afterVisibleChange"
        @close="onClose"
      >
        <div @click="onClose" style="cursor: pointer;padding: 24px 24px 0px" >
          <a-icon type="left" />
          <span style="color: #262626; display: inline-block; margin-left: 10px;">返回</span>
        </div>
        <div style="margin-top: 50px;padding-left: 24px">
          <img src="@/assets/ke_fu_tu.png" alt="" style="width: 176px; height: auto;">
        </div>
      </a-drawer>
    </div>
    <div class="zhi_nan" >
      <div class="zhi_nan1" v-for="icon of addressIcon1" :key="icon.id" @mouseover="changeColor1" @mouseleave="reColor1">
        <img :src="icon.icon" alt="">
        <br>
        <a href="https://www.yuque.com/books/share/fd60d8e4-dc8c-4e54-b56e-206d09373631?# 《绿萝心理云平台使用手册》" target="_blank" :style="active1" class="a1" @click=toOtherLink1() >
        用户手册
      </a>
      </div>
      <div class="zhi_nan2" tabindex="2" v-for="icon of addressIcon2" :key="icon.id" @mouseover="changeColor2" @mouseleave="reColor2">
        <img :src="icon.icon" alt="">
        <br>
        <a href="https://support.qq.com/product/516737" target="_blank" class="a2" :style="active2"  @click=toOtherLink2()>
       产品反馈
      </a>
      </div>
    </div>
    <div v-if="updateVisible || updateNoticeVisible" class="update_info">
      <div class="update_warp">
        <div class="update_inner">
          <div class="inner_top">
            <img src="@/assets/update_tu.png" alt="">
          </div>
          <div class="inner_foot">
            <h2 style="color: #262626; font-size: 24px;">平台更新</h2>
            <p>1.现已支持班主任绑定多个班级</p>
            <p>2.修复已知的问题</p>
            <div style="margin-top: 50px; text-align: right;">
              <a-button style="margin-right: 16px;" @click="detailHand">查看详情</a-button>
              <a-button type="primary" @click="okHandle" :disabled="ableState">确认</a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 到期续费 -->
    <div class="update_info" @click="stopHand" v-if="endTimeBox && roleID === 1 && endNum !== 1">
      <div class="update_warp">
        <div class="end_box" :class="{trans: actShow}"  @click.stop="stopEnd">
          <div class="end_top">
            <img v-if="endNum === 2" src="@/assets/end_1.png" alt="" class="top_pic">
            <img v-if="endNum === 0" src="@/assets/end_2.png" alt="" class="top_pic">
            <img src="@/assets/close_circle.png" alt="" class="top_close" @click.self="endTimeHandle">
          </div>
          <div class="end_foot">
            <div class="foot_item foot_flex">
              <div>
                <div class="part_one foot_flex">
                  <img src="@/assets/kaixin.png" alt="">
                  <span>老师您好~</span>
                </div>
                <div v-if="endNum === 2" class="part_two">平台服务将于<span>{{endDate}}</span>到期</div>
                <div v-if="endNum === 0" class="part_two">平台服务已于<span style="color: #FF5219;">{{endDate}}</span>到期</div>
                <div class="part_two two_special">请联系校园管家及时续费</div>
                <p class="part_three">微信扫描右侧二维码，即可添加校园管家</p>
              </div>
              <div class="part_four">
                <img src="@/assets/weixin_icon.png" alt="">
              </div>
            </div>
            <div class="foot_item foot_flex">
              <div class="part_five five_col">
                <h4 style="color: #51BF94;">到期后您可以</h4>
                <span>查看学生心理档案</span>
                <span>查看报告库</span>
                <span>查看危机预警数据</span>
              </div>
              <div class="part_five six_col">
                <h4 style="color: #FFAF18;">到期后我们将关闭</h4>
                <span>学生测评任务</span>
                <span>教师测评任务</span>
                <span>教师自主测评</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import NavTop from './NavTop'
import axios from 'axios'

export default {
  name: 'MainView',
  data () {
    return {
      addressIcon1:[
        {
          icon:require('@/assets/矩形.png'),
          id:'1'
        }
      ],
      addressIcon2:[
        {
          icon:require('@/assets/学生列表.png'),
          id:'2'
        }
      ],
      active1:'',
      active2:'',
      visible: false,
      updateVisible: false,
      ableState: false,
      isShow: true,
      endNum: null,
      roleID: null,
      endDate: null
    }
  },
  components: {
    NavTop
  },
  computed: {
    ...mapState([
      'userInfo',
      'spinning',
      'totalSpinning',
      'uploadCancel',
      'classVisible',
      'updateNotices',
      'updateNoticeVisible',
      'importPro',
      'endTimeBox',
      'actShow',
      'questionnairenTask',
      'schoolTaskList',
      'dataManagementShwoProgress',
      'exportProgress',
      'exportProgressOther',
      'teacherAdmin'
    ])
  },
  watch: {
    $route (to) {
      if (to.name !== 'DeskView') {
        this.isShow = false
      } else {
        this.isShow = true
      }
    },
    questionnairenTask () {
      if (this.userInfo.type === 1) { // 教育局
        this.setSpinning(false)
      } else if (this.userInfo.type === 2) { // 单校
        if (this.schoolTaskList) {
          this.setSpinning(false)
        }
      } else { // 教育局和单校
        if (this.questionnairenTask && this.schoolTaskList) {
          this.setSpinning(false)
        }
      }
    },
    schoolTaskList () {
      if (this.userInfo.type === 1) { // 教育局
        this.setSpinning(false)
      } else if (this.userInfo.type === 2) { // 单校
        if (this.schoolTaskList) {
          this.setSpinning(false)
        }
      } else { // 教育局和单校
        if (this.questionnairenTask && this.schoolTaskList) {
          this.setSpinning(false)
        }
      }
    }
  },
  async mounted () {
    this.setSpinning(true)
    let qudao = sessionStorage.getItem('qudao') ? JSON.parse(sessionStorage.getItem('qudao')) : null
    if (qudao) {
      document.querySelector('link[rel="icon"]').href = qudao.logo_url
      document.querySelector('title').innerHTML = qudao.qudao_name
    }
    let moment = require('moment')
    this.endNum = JSON.parse(sessionStorage.getItem('userInfo')).end_num
    this.roleID = JSON.parse(sessionStorage.getItem('userInfo')).role_id
    this.endDate = moment(JSON.parse(sessionStorage.getItem('userInfo')).end_time).format('YYYY年MM月DD日')
    let response = await this.getUpdateNotice()
    if (response) {
      this.updateVisible = true
    } else {
      this.updateVisible = false
    }
    await this.getSchoolInfos({skip: 0})
  },
  methods: {
    reColor1(){
      if(this.addressIcon1[0] ){
        this.addressIcon1[0].icon = require(`@/assets/矩形.png`)
        this.addressIcon2[0].icon = require(`@/assets/学生列表.png`)
        this.active1="color:black"
      }
    },
    reColor2(){
      if(this.addressIcon2[0] ){
        this.addressIcon2[0].icon = require(`@/assets/学生列表.png`)
        this.addressIcon1[0].icon = require(`@/assets/矩形.png`)
        this.active2="color:black"
      }
    },
    changeColor1(){
      if(this.addressIcon1[0] ){
        this.addressIcon1[0].icon = require(`@/assets/矩形(1).png`)
        this.addressIcon2[0].icon = require(`@/assets/学生列表.png`)
        this.active1="color:#50BF94FF"
        this.active2=''
      }
    },
    changeColor2(){
      if(this.addressIcon2[0] ){
        this.addressIcon2[0].icon = require(`@/assets/Shape(1).png`)
        this.addressIcon1[0].icon = require(`@/assets/矩形.png`)
        this.active1=''
        this.active2="color:#50BF94FF"
      }
    },
    toOtherLink1(){
      if(this.addressIcon1[0] && this.addressIcon2[0] ){
        this.addressIcon1[0].icon = require(`@/assets/矩形(1).png`)
        this.addressIcon2[0].icon = require(`@/assets/矩形.png`)
      }
   
    },
    toOtherLink2(){
      if(this.addressIcon1[0] && this.addressIcon2[0] ){
        this.addressIcon2[0].icon = require(`@/assets/Shape(1).png`)
        this.addressIcon1[0].icon = require(`@/assets/学生列表.png`)
      }
    },
    ...mapActions([
      'getSchoolInfos',
      'getUpdateNotice',
      'setUpdateNoticeBtn'
    ]),
    ...mapMutations([
      'setSpinning',
      'setTotalSpinning',
      'setUpdateNoticeVisible',
      'setEndTimeBox',
      'setActShow'
    ]),
    cardClick (link) {
      window.open(link)
    },
    clearHandle () {
      this.uploadCancel('终止请求')
      this.setTotalSpinning(false)
      this.$router.push('/studentList/studentInfo')
    },
    afterVisibleChange(val) {
      console.log('visible', val);
    },
    showDrawer() {
      this.visible = true
    },
    onClose() {
      this.visible = false
    },
    async okHandle () {
      this.ableState = true
      if (this.updateVisible) {
        this.updateVisible = false
        await this.setUpdateNoticeBtn()
      }
      this.setUpdateNoticeVisible(false)
      let response1 = await axios.get(`https://api.lvluoxinli.com/api/odata/jingang/Odata.xsodata/TEACHER_PAGE_ISVIEW?$filter=UID eq ${this.teacherAdmin.uid} and PAGE_NAME eq 5`)
      console.log(response1.data.d.results[0].UID,'response')
      if(response1.data.d.results[0].UID && response1.data.d.results[0].C_TIME && response1.data.d.results[0].PAGE_NAME){
        this.ableState = false
      }
      // setTimeout(() => {
      //   this.ableState = false
      // }, 2000)
    },
    detailHand () {
      window.open('https://www.yuque.com/docs/share/c34fa531-5dc5-4ab9-85e6-c91f65858af8?# 《2021.6.22更新说明》')
    },
    // 到期续费
    endTimeHandle () {
      setTimeout(() => {
        this.setEndTimeBox(false)
      }, 150)
      this.setActShow(true)
    },
    stopEnd () {
      console.log('阻止冒泡')
    },
    stopHand () {
      if (this.endTimeBox) {
        this.setEndTimeBox(false)
        this.setActShow(true)
      }
    },
    fixedFun (value) {
      if (parseFloat(value) === parseInt(value)) {
        return value
      } else {
        return value.toFixed(2)
      }
    }
  }
}
</script>

<style>
#main_view {
  width: 100%;
  height: 100%;
}
.boxDivs {
  padding-top: 60px;
}
.serveDiv {
  width: 100%;
  display: flex;
  justify-content: center;
}
.serveDiv .serveDivContent {
  width: 1200px;
  /* padding: 38px 0px 32px; */
}
.serveDiv .serveDivContent img {
  width: 100%;
  height: auto;
  cursor: pointer;
  transition: all 0.4s;
  transform: translateY(0px);
}
.serveDiv .serveDivContent img:hover {
  transform: translateY(-8px);
}
.serveDiv .serveDivContent h2 {
  color: #FFFFFF;
  font-size: 24px;
}
.serveDiv .serveDivContent .cardDiv {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.serveDiv .serveDivContent .cardDiv .ant-card-bordered {
  flex-basis: 24.5%;
  background-color: #FFFFFF;
  border-width: 0px;
}
.serveDiv .serveDivContent .cardDiv .ant-card-bordered:hover {
  box-shadow: 2px 2px 10px #00311D;
}
.serveDiv .serveDivContent .cardDiv > img {
  width: 100%;
  height: auto;
}
.serveDiv .serveDivContent .cardDiv  .cardText {
  display: flex;
  flex-direction: column;
}
.serveDiv .serveDivContent .cardDiv div b {
  font-size: 16px;
  margin-bottom: 8px;
}
.serveDiv .serveDivContent .cardDiv div span {
  color: rgba(23, 26, 29, 0.6);
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 12px;
}
.serveDiv .serveDivContent .cardDiv div a {
  display: flex;
  align-items: center;
  color: #0089FF;
}
.serveDiv .serveDivContent .cardDiv div a img {
  width: 14px;
  height: auto;
  margin-left: 8px;
}
#main_view .contents {
  width: 100%;
  display: flex;
  justify-content: center;
}
#main_view .contents .content-box {
  width: 1200px;
}
#main_view .ant-spin-blur::after {
  opacity: 0.9;
}
#main_view .ant-spin-container::after {
  z-index: 1000;
}
#main_view .spin_btn {
  width: 640px;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 10000;
  margin-left: -320px;
  text-align: center;
}
#main_view .spin_btn .clear_btn:hover, #main_view .spin_btn .clear_btn:focus {
  color: #F58622;
  border-color: #F58622;
}
#main_view .spin_btn p {
  margin-bottom: 50px;
}
 #main_view .ke_fu {
  position: fixed;
  right: 24px;
  z-index: 900;
}
  #main_view .zhi_nan {
  border-radius: 8px 8px 8px 8px;
  margin:0 auto;
  position: fixed;
  right: 0px;
  padding-top: 15px;
  height: 150px;
  width: 70px;
  bottom: 200px;
  background: #FFFFFF;
  text-align: center;
  border: 2px solid #50BF94FF;
  box-shadow: -1px 2px 1px #50BF94FF
}
.zhi_nan .zhi_nan1 {
  height: auto;
}
 /* .zhi_nan .zhi_nan2 .a2:focus {
  color: #51BF94;
}
.zhi_nan .zhi_nan1 .a1:focus{
  color:#51BF94
} */
.zhi_nan1 a {
  color:#000;
}
 .zhi_nan .zhi_nan1 img {
  margin-bottom: 5px;
}
.zhi_nan .zhi_nan2 img {
  margin-bottom: 5px;
}
.zhi_nan .zhi_nan2 {
  height: auto;
  margin-top: 25px;
}
.zhi_nan .zhi_nan2 a {
  height: auto;
  margin-top: 30px;
  color: #000;
}
#main_view .ke_fu {
  bottom: 240px;
  cursor: pointer;
}
 #main_view .ke_fu img {
  width: 50px;
  height: auto;
}
 .zhi_nan1 img{
  /* background: violet; */
  width: 20px;
  height: 20px;
}
#main_view .deskHeader .showHide {
  color: #BFBFBF;
}
#main_view .update_info {
  position: fixed;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  z-index: 2000;
  background-color: rgba(0, 0, 0, .4);
}
#main_view .update_info .update_warp {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
#main_view .update_warp .update_inner {
  width: 500px;
  background-color: #FFFFFF;
}
#main_view .update_warp .update_inner .inner_top img {
  width: 100%;
  height: auto;
}
#main_view .update_warp .update_inner .inner_foot {
  padding: 24px;
  box-sizing: border-box;
}
#main_view .update_warp .update_inner .inner_foot > p {
  margin: 16px 0px 0px;
}
#main_view .update_warp .update_inner .inner_foot .ant-btn-primary {
  color: #FFFFFF;
  background-color: #51BF94;
}
#main_view .update_warp .update_inner .inner_foot .ant-btn-primary:hover {
  color: #FFFFFF;
  background-color:rgba(81, 191, 148, .7);
}
#main_view > .ant-spin-nested-loading > div > .ant-spin {
  display: none;
}
#main_view > .spin_btn {
  transform: translateY(-60%);
}
.spin_btn .ant-progress-line {
  width: 300px!important;
}
#main_view .update_warp .end_box {
  width: 600px;
  position: relative;
  z-index: 3000;
  border-radius: 4px;
  background-color: #FFFFFF;
  transform: scale(1);
  opacity: 1;
  transition: all .18s;
}
#main_view .update_warp .trans {
  opacity: 0;
  transform: scale(0);
}
#main_view .update_warp .trans_two {
  opacity: 1;
  transform: scale(1);
}
#main_view .update_warp .end_top {
  position: relative;
}
#main_view .update_warp .end_top .top_pic {
  width: 100%;
  height: auto;
}
#main_view .update_warp .end_top .top_close {
  position: absolute;
  right: 40px;
  width: 16px;
  height: auto;
  top: 24px;
  cursor: pointer;
}
#main_view .update_warp .end_foot {
  padding: 40px;
}
#main_view .update_warp .end_foot .foot_flex {
  display: flex;
  align-items: center;
}
#main_view .update_warp .end_foot .foot_item {
  color: #262626;
  justify-content: space-between;
}
#main_view .update_warp .end_foot .foot_item:last-child {
  margin-top: 32px;
}
#main_view .update_warp .end_foot .part_one {
  margin-bottom: 16px;
}
#main_view .update_warp .end_foot .part_one img {
  width: 24px;
  height: auto;
  margin-right: 8px;
}
#main_view .update_warp .end_foot .part_one span, #main_view .update_warp .end_foot .part_two, #main_view .update_warp .end_foot .part_three, #main_view .update_warp .end_foot .part_five {
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  line-height: 18px;
}
#main_view .update_warp .end_foot .two_special {
  margin: 8px 0px 16px;
}
#main_view .update_warp .end_foot .part_two span {
  margin: 0px 16px;
  color: #FFAD13
}
#main_view .update_warp .end_foot .part_three {
  font-size: 14px;
  color: rgba(23, 26, 29, 0.4);
}
#main_view .update_warp .end_foot .part_four img {
  width: 114px;
  height: auto;
}
#main_view .update_warp .end_foot .part_five {
  font-size: 14px;
  font-weight: 500;
  box-sizing: border-box;
}
#main_view .update_warp .end_foot .part_five h4 {
  font-size: 18px;
  margin-bottom: 10px;
}
#main_view .update_warp .end_foot .part_five span {
  display: block;
  margin-top: 8px;
}
#main_view .update_warp .end_foot .five_col {
  padding: 16px 95px 16px 16px;
  color: #51BF94;
  background-color:rgba(81, 191, 148, .1);
}
#main_view .update_warp .end_foot .six_col {
  padding: 16px 122px 16px 16px;
  color: #FFAF18;
  background-color:rgba(255, 173, 19, .1);
}
#main_view .exportProgress {
  width: 640px;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 10000;
  margin-left: -320px;
  text-align: center;
  transform: translateY(-50%);
}
#main_view p {
  margin-bottom: 50px;
}
</style>
